module.exports = __webpack_public_path__ + "img/camping.be5030ca.webp";